import React from "react";
import { mockData } from "../mock";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { MapPin } from "lucide-react";
import { Button } from "./ui/button";

const Destinations = () => {
  // Separate special events from regular tours
  const regularTours = mockData.destinations.filter(d => d.type !== "Evento Especial");
  const specialEvents = mockData.destinations.filter(d => d.type === "Evento Especial");

  return (
    <section id="destinos" className="py-24 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nuestros Tours por Europa
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Acceso exclusivo a los clubes más importantes de Europa. Experimenta de primera mano cómo operan las organizaciones de élite, construye tu red de contactos y aprende directamente en el terreno con expertos de la industria.
          </p>
        </div>

        {/* Special Events Section */}
        {specialEvents.length > 0 && (
          <div className="mb-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              🌟 Eventos Especiales 2026
            </h3>
            <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
              {specialEvents.map((event) => (
                <Card
                  key={event.id}
                  className="group overflow-hidden cursor-pointer hover:shadow-2xl transition-all duration-300 border-4 border-yellow-500 relative"
                >
                  <div className="absolute top-4 left-4 z-10">
                    <Badge className="bg-red-500 text-white font-bold text-sm border-none animate-pulse">
                      PLAZAS LIMITADAS
                    </Badge>
                  </div>
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={event.image}
                      alt={event.country}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent"></div>
                    <div className="absolute bottom-4 left-4 right-4 text-white">
                      <Badge className="bg-yellow-500 text-gray-900 font-semibold border-none mb-3">
                        {event.type}
                      </Badge>
                      <h3 className="text-2xl font-bold mb-2">{event.country}</h3>
                      <div className="flex items-start text-white text-sm">
                        <MapPin className="h-4 w-4 mr-2 mt-0.5 flex-shrink-0 text-yellow-500" />
                        <span>{event.cities}</span>
                      </div>
                    </div>
                  </div>
                  <CardContent className="p-6 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
                    <p className="text-base mb-4">{event.description}</p>
                    <Button className="w-full bg-gradient-to-r from-yellow-500 to-amber-500 hover:from-yellow-600 hover:to-amber-600 text-gray-900 font-bold">
                      Más Información
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        )}

        {/* Regular Tours Section */}
        <div>
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Tours Regulares por Europa
          </h3>
          <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-6 mb-12">
            {regularTours.map((destination) => (
              <Card
                key={destination.id}
                className="group overflow-hidden cursor-pointer hover:shadow-2xl transition-all duration-300 border-2 hover:border-yellow-500"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={destination.image}
                    alt={destination.country}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                  <Badge className="absolute top-3 right-3 bg-yellow-500 text-gray-900 font-semibold border-none">
                    {destination.type}
                  </Badge>
                </div>
                <CardContent className="p-5">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-yellow-600 transition-colors">
                    {destination.country}
                  </h3>
                  <div className="flex items-start text-gray-600 text-sm mb-2">
                    <MapPin className="h-4 w-4 mr-2 mt-0.5 flex-shrink-0 text-yellow-600" />
                    <span>{destination.cities}</span>
                  </div>
                  {destination.description && (
                    <p className="text-xs text-gray-500 mt-2">{destination.description}</p>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        <div className="text-center">
          <button className="text-yellow-600 hover:text-yellow-700 font-bold text-lg hover:underline transition-colors">
            Ver Todos los Tours
          </button>
        </div>
      </div>
    </section>
  );
};

export default Destinations;
